// services/static-content.service.ts
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { STATIC_CONTENTS } from '../data/html-contents';
import { HERBS } from '../data/herbs';
import { SafeHtml } from '@angular/platform-browser';
import { Herb } from '../models/herb.model';





export interface TocItem {
    id: string;
    title: string;
}

export interface ResourceItem {
    title: string;
    url: string;
    sitename: string;
}

export interface InfoContent {
    category: 'kraeuter' | 'tees' | 'gesundheit'; // Mehrere Kategorien mit Union Type
    readingTime: number;
    title: string;
    slug: string;
    mainImageUrl?: string;
    mainImageAlt?: string;
    seo: any;
    abstract: string;
    
    // Typisierte Arrays statt generisches object[]
    tocItems: TocItem[] | undefined;
    
    // htmlContent als SafeHtml Typ für das DomSanitizer-Ergebnis
    htmlContent: string | SafeHtml;
    
    // Typisiertes Array für Ressourcen
    additionalResources: ResourceItem[] | undefined;
}

@Injectable({
  providedIn: 'root'
})
export class ContentService {

    getPopularHerbs(count: number = 7): Herb[] {
        return HERBS.slice(0, count);
    }

    getHerbById(id: string): Herb | undefined {
        return HERBS.find(herb => herb.id === id);
    }

    getAllHerbs(): Herb[] {
        return [...HERBS];
    }
    
    getContentByCategoryAndSlug(category: string, slug: string): Observable<InfoContent | null> {
        const content = STATIC_CONTENTS.find(
            item => 
                item.category.toLowerCase() === category.toLowerCase() && 
                item.slug.toLowerCase() === slug.toLowerCase()
        );
        return of(content || null);
    }
}